import ApiService from './api.service'

const CustomerGroupService = {
  async list() {
    try {
      return await ApiService.get('customer/groups')
    } catch (error) {
      return error.response
    }
  },
  async get(id) {
    try {
      return await ApiService.get('customer/group/' + id)
    } catch (error) {
      return error
    }
  },

  async create(data) {
    try {
      return await ApiService.post('customer/group', data)
    } catch (error) {
      return error
    }
  },

  async update(data, id) {
    try {
      return await ApiService.put('customer/group/' + id, data)
    } catch (error) {
      return error
    }
  },

  async syncDealers(data) {
    try {
      return await ApiService.put('customer/group/sync-dealers/' + data.id, data)
    } catch (error) {
      return error
    }
  }
}

export { CustomerGroupService }
